import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, MessageBanner, Modal, ModalFooter, TextArea, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { LIBRARY_NOTE_MAX_LENGTH, LIBRARY_NOTE_WARNING_THRESHOLD, } from "../../types/titleLibraryNote";
import styles from "./LibraryNoteDialog.module.css";
export var BulkLibraryNoteDialog = function (_a) {
    var open = _a.open, selectedCount = _a.selectedCount, onClose = _a.onClose, onSubmit = _a.onSubmit, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    var _c = useState(""), text = _c[0], setText = _c[1];
    useEffect(function () {
        if (!open)
            setText("");
    }, [open]);
    var handleClose = useCallback(function () {
        setText("");
        onClose();
    }, [onClose]);
    var handleSubmit = useCallback(function () {
        onSubmit(text.trim());
    }, [text, onSubmit]);
    var tooLong = text.length > LIBRARY_NOTE_MAX_LENGTH;
    var isValid = text.trim().length > 0 && !tooLong && selectedCount > 0;
    var counterClass = useMemo(function () {
        if (tooLong)
            return styles.counterError;
        if (text.length > LIBRARY_NOTE_WARNING_THRESHOLD)
            return styles.counterWarning;
        return styles.counter;
    }, [tooLong, text.length]);
    return (React.createElement(Modal, { open: open, label: formatMessage({
            id: "ui-br-legaldeposits.bulk.libraryNote.title",
        }), onClose: handleClose, size: "small", footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit, disabled: !isValid || isLoading },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.confirm" })),
            React.createElement(Button, { onClick: handleClose },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" }))) },
        React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.libraryNote.summary", values: { count: selectedCount } })),
        React.createElement(TextArea, { "data-testid": "bulk-library-note-textarea", label: formatMessage({
                id: "ui-br-legaldeposits.title.libraryNote.label",
            }), value: text, onChange: function (e) {
                return setText(e.target.value);
            }, required: true }),
        React.createElement("div", { className: counterClass, "data-testid": "bulk-library-note-counter" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.title.libraryNote.dialog.counter", values: { count: text.length } }))));
};
